import React from "react";
import { Breadcrumb } from "../../../components/Breadcrumb";

export const Terms = () => {
    document.title = "Terminlər";

    const menu = [
        { name: "Ana səhifə", value: "/" },
        { name: "Ümumi anlayışlar", value: "/common" },
        { name: "Terminlər", value: "/common/terms", current: true },
    ];

    return (
        <div>
            <Breadcrumb menu={menu} />
            <div className="container">
                <article>
                    <h2 className="my-4">Terminlər</h2>
                    <p>
                        <ol>
                            <li>
                                <b>Sənəd</b> ⮞ Məhsullar ilə yerinə yetirilən bütün hərəkətlər (alış, satış, qaytarma, daxilolma, silinmə, yerdəyişmə, sifariş)
                                sənədlər şəklində icra olunur
                            </li>
                            <li>
                                <b>Məhsul</b> ⮞ Sistemdə mövcud olan mallardır
                            </li>
                            <li>
                                <b>Anbar</b> ⮞ Məhsulların yerləşdiyi məkanı xarakterizə edir
                            </li>
                            <li>
                                <b>Tərəf müqabil</b> ⮞ Qarşı tərəf ilə olunacaq müqavilələr
                            </li>
                            <li>
                                <b>Qazanc</b> ⮞ Məhsul satışından ilkin yaranan, xərcsiz mənfəətdir
                            </li>
                            <li>
                                <b>Marja</b> ⮞ Gəlirlilik faizidir
                            </li>
                            <li>
                                <b>Mənfəət</b> ⮞ Məhsulların ilkin qazancıdır
                            </li>
                            <li>
                                <b>Alış</b> ⮞ Təchizatçıdan alınan məhsulların qeyd olunduğu sənəddir
                            </li>
                            <li>
                                <b>Alışın geriqaytarması</b> ⮞ Təchizatçılara qaytarılan məhsulların qeyd olunduğu sənəddir
                            </li>
                            <li>
                                <b>Alışın sifarişi</b> ⮞ Təchizatçıdan alınacaq məhsulların qeyd olunduğu sənəddir
                            </li>
                            <li>
                                <b>Minimal qalıq</b> ⮞ Təchzatçılardan alınacaq məhsulların formlaşması üçün nəzərdə tutulub
                            </li>
                            <li>
                                <b>Satış</b> ⮞ Alıcılara satılan məhsulların qeyd olunduğu sənəddir
                            </li>
                            <li>
                                <b>Satışın geriqaytarması</b> ⮞ Alıcılara qaytarılan məhsulların qeyd olunduğu sənəddir
                            </li>
                            <li>
                                <b>Satışın sifarişi</b> ⮞ Alıcıların sifariş etdiyi məhsulların qeyd olunduğu sənəddir
                            </li>
                            <li>
                                <b>Daxilolma</b> ⮞ Anbara daxil olacaq məhsulların qeyd olunduğu sənəddir
                            </li>
                            <li>
                                <b>Silinmə</b> ⮞ Anbardan silinəcək məhsulların qeyd olunduğu sənəddir
                            </li>
                            <li>
                                <b>Yerdəyişmə</b> ⮞ Anbarlar arası məhsul yerdəyişmələrinin qeyd olunduğu sənəddir
                            </li>
                            <li>
                                <b>Anbar qalığı</b> ⮞ Anbarlarda olan məhsulların siyahısı olan bölmədir
                            </li>
                            <li>
                                <b>Maliyyə</b> ⮞ Pul hərəkətidir
                            </li>
                            <li>
                                <b>Komisyon satış</b> ⮞ Səyyar şəkildə icra olunan satışların qeyd olunkası üçündür
                            </li>
                            <li>
                                <b>Cavabdeh</b> ⮞ Sənədi yaradan iftifadəçi
                            </li>
                            <li>
                                <b>Dövriyyə</b> ⮞ Məhsulların bütün hərəkətidir
                            </li>
                            <li>
                                <b>Balans</b> ⮞ Pulların göstəricisidir
                            </li>
                            <li>
                                <b>İstehsalat</b> ⮞ Bir neçə xammaldan məhsul hazırlanması prosesidir
                            </li>
                            <li>
                                <b>Yoxlama</b> ⮞ Mayanın formalaşması zamanı ardıcıllıq ilə bağlı yaranan xətalı məhsulların siyahısıdır
                            </li>
                        </ol>
                    </p>
                </article>
            </div>
        </div>
    );
};
